<div class="dialog-content">
    <h2>{{ data.mode === 'view' ? 'Information état redirection' : 'Modifier l\'état redirection' }}</h2>

    <form [formGroup]="form" class="form-fields">

        <!-- Nom (toujours readonly) -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Nom</mat-label>
            <input matInput formControlName="name" />
        </mat-form-field>

        <!-- Assigné à (toujours readonly) -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Assigné à</mat-label>
            <input matInput formControlName="extensionId" />
        </mat-form-field>

        <!-- Destination (toujours readonly) -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Destination</mat-label>
            <input matInput formControlName="target" />
        </mat-form-field>

        <!-- Actif -->
        <div class="toggle-line">
            <mat-slide-toggle class="primary-button" formControlName="enabled">Actif</mat-slide-toggle>
            <span class="status" [ngClass]="form.get('enabled')?.value ? 'status-yes' : 'status-no'">
                {{ form.get('enabled')?.value ? 'oui' : 'non' }}
            </span>
        </div>

        <!-- Temps max -->
        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Temps max (s)</mat-label>
            <input matInput type="number" formControlName="ringSeconds" />
        </mat-form-field>

    </form>

    <!-- Historique -->
    @if (data.mode === 'view') {
    <app-historique [uidObject]="data.rule.id" [uidEntreprise]="data.rule.organizationId" [limit]="5">
    </app-historique>
    }

    <!-- Actions -->
    <div class="dialog-actions">
        <button mat-stroked-button class="accent-button" (click)="onClose()">Fermer</button>
        @if (data.mode === 'edit') {
        <button mat-raised-button class="accent-button" (click)="onSave()" [disabled]="form.invalid">
            Modifier
        </button>
        }
    </div>
</div>